import { useState } from "react";
import {
  MiBuildPageHeader,
  MiButton,
  MiContentDrawer,
  MiIcon,
} from "@miplatform/components";
import {
  APP_BAR_HEIGHT,
  APP_BAR_HEIGHT_TABLET,
  ICONS_WEB,
  MIBUILD_PAGE_HEADER_HEIGHT,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { MiActivityLog } from "@mibuildweb/components";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useHomeActivityDrawerViewModel } from "./useHomeActivityDrawerViewModel";

export function HomeActivityDrawer({
  home,
  open,
  handleViewOrderFromActivity,
  onClose = () => null,
}) {
  const theme = useTheme();
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [search, setSearch] = useState("");

  const {
    filteredOrderActivities,
    isLoading,
    dateRange,
    handleDateRangeChange,
  } = useHomeActivityDrawerViewModel({
    home,
    open,
    search,
  });

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleClose = () => {
    onClose();
    setSearch("");
  };

  const header = (
    <MiBuildPageHeader
      title="Activity Log"
      titleVariant="h6"
      titleColor="primary.main"
      titleFontWeight={theme.fontWeight.semiBold}
      titleIcon={
        <Box
          backgroundColor={theme.palette.primary.light}
          borderRadius={2}
          padding={1}
          width={28}
          height={28}
        >
          <MiIcon
            path={mdi[ICONS_WEB.HISTORY]}
            size={0.8}
            color={theme.palette.primary.dark}
            data-testid="left-icon"
          />
        </Box>
      }
      hasDivider
      style={{ minHeight: 48 }}
      search={search}
      searchPlaceholder="Search activity"
      onHandleSearch={(e) => handleSearch(e.target.value)}
      actionComponent={
        <Box display="flex" alignItems="center" gap={3}>
          <MiButton
            startIcon={{
              path: mdi[ICONS_WEB.CLOSE],
              iconColor: theme.palette.grey.main,
            }}
            onClick={handleClose}
            data-testid="right-icon-button"
            style={{ padding: theme.spacing(1) }}
          />
        </Box>
      }
    />
  );

  const DRAWER_TOP_OFFSET =
    (isTablet ? APP_BAR_HEIGHT_TABLET : APP_BAR_HEIGHT) +
    MIBUILD_PAGE_HEADER_HEIGHT;

  return (
    <MiContentDrawer
      variant="persistent"
      open={open}
      onClose={handleClose}
      Header={header}
      slotProps={{
        transition: {
          unmountOnExit: true,
        },
      }}
      hideBackdrop
      sx={{
        "& > .MuiPaper-root": {
          top: DRAWER_TOP_OFFSET,
          height: `calc(100% - ${DRAWER_TOP_OFFSET}px)`,
        },
      }}
    >
      <MiActivityLog
        activities={filteredOrderActivities}
        isLoading={isLoading}
        dateRange={dateRange}
        onDateRangeChange={handleDateRangeChange}
        showOrderTemplate
        onActivityClick={handleViewOrderFromActivity}
      />
    </MiContentDrawer>
  );
}
